import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Title, DomSanitizer } from '@angular/platform-browser';
import { AppService } from '../../../app.service';
import { TranslateService } from '../../../translate';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { NotificationsService } from 'angular2-notifications';
import { Location, DatePipe } from '@angular/common';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/of';
import { SetupUndercarriageService } from '../setup-undercarriage.service';
import {
    CurrentSelection, SelectionLists,
    Customer, JobSite, UCSystem,
    SystemType, Side, ComponentSetup, Compart, Model, SystemModelTemplate,
    ShoeSize, Make, ComponentGrouser, Family,
    SystemSetup, ResultMessage, AppRoute, MakeModelFamily, SystemStructureInformation
} from '../../../entities';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { LoadingService } from '../../../shared/services/loading.service';
import { GeneralActionViewModel } from '../../action/action-models';
import { ActionService } from '../../action/action.service.service';
import { DataSource } from '@angular/cdk/table';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatSnackBar } from '@angular/material/snack-bar';

enum SystemTypeSide {
    LeftChain = 1,
    RightChain = 2,
    LeftFrame = 3,
    RightFrame = 4
}

enum RouteControl {
    Customer = 1,
    JobSite = 2,
    Route = 3
}

@Component({
  selector: 'app-setup-undercarraige-action',
  templateUrl: './setup-undercarraige-action.component.html',
  styleUrls: ['../setup-undercarriage.component.scss'],
  providers: [
    DatePipe,
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' },
],
})
export class SetupUndercarraigeActionComponent implements OnInit {

 
  translateSubscription: Subscription;
  userLanguage = 'english';
  _currentSelection: CurrentSelection = new CurrentSelection();

  isLinear = false;

  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;

  _dropDownLists: SelectionLists = new SelectionLists();
  _dropDownListsFiltered: SelectionLists = new SelectionLists();

  _leftChainSetup: SystemSetup = new SystemSetup();
  _leftFrameSetup: SystemSetup = new SystemSetup();


  _currentAvailableTypes: Compart[] = [];
  _availableShoeSizes: ShoeSize[] = [];
  _availableGrousers: ComponentGrouser[] = [{ Id: 0, Title: 'Unknown' }, { Id: 1, Title: 'Single Grouser' }, { Id: 2, Title: 'Double Grouser' }, { Id: 3, Title: 'Triple Grouser' }];
  _availableComponentMakes: Make[] = [];



  leftchainTableDatabase: ComponentTableDatabase | null;
  leftchainTableDataSource: ComponentDataSource | null;

  leftframeTableDatabase: ComponentTableDatabase | null;
  leftframeTableDataSource: ComponentDataSource | null;

  _selectedIndex = 0;
  _selectedSystemTypeIsChain = true;
  _updateExisting = false;
  _displayedColumns = ['delete', 'Component', 'Type', 'Pos', 'Brand', 'BudgetLife', 'HoursAtInstall', 'InstallCost', 'Size', 'Grouser','CleanerHoles'];
  _LoadedLists: RouteControl[] = [];
  _loading = 0;
  _lockModel = false;
  _routeId = 0;
  isLoading = false;



  SystemStructureInformation: SystemStructureInformation;

  submittedSucessfully = false;

  private _systemTemplate: SystemModelTemplate[] = [];
  routeSubscription: Subscription;

  jobsiteId: number;
  systemType: number;
  equipmentId: number;
  selectedSystemId: number;
  isCreatingFromAction = false;

   _equipment = new MakeModelFamily();


  FamilyImage_Chain: string
  FamilyImage_Frame: string
  public shouldShouldChainAndFrameSelection: boolean;
  _originalSystem: SystemStructureInformation;
  Installed: boolean = false;
  useMax: string;
  hideSerial:boolean=false;


  //added variables
  SMUHours:number;
  PMUHours:number;

  LabourCost:number=0;
  MiscCost:number=0;
  action = new GeneralActionViewModel();
  Comment:string;
  constructor(
      private _setupService: SetupUndercarriageService,
      private _appService: AppService,
      private titleService: Title,
      private _router: Router,
      private ref: ChangeDetectorRef,
      private route: ActivatedRoute,
      private _loadingService: LoadingService,
      private _translate: TranslateService,
      private _formBuilder: FormBuilder,
      public snackBar: MatSnackBar,
      private location: Location,
      private _notification: NotificationsService,
      private _sanitizer: DomSanitizer,
      private _actionService:ActionService) {
  }

  ngOnInit() {
      this._appService.setPageTitle('Setup Undercarriage | In Inventory');

      this.isLoading = true;

      this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2));
      this.firstFormGroup = this._formBuilder.group({
          firstCtrl: ['', Validators.required]
      });
      this.secondFormGroup = this._formBuilder.group({
          secondCtrl: ['', Validators.required]
      });
      this._loading++;
      this._setupService.getShoeSizeList().subscribe(result => {
          this._availableShoeSizes = result;
      }, error => { console.error(error); }, () => { this._loading--; });


      const componentMakeList = this._setupService.getComponentMakeList();
      const customerList = this._appService.getCustomerListForSelection(1, 10000);
      const jobsiteList = this._appService.getJobSiteListForSelection(1, 10000);
      const familyList = this._appService.getFamilyListForSelection(1, 10000);
      const makeList = this._appService.getMakeListForSelection(1, 10000);
      const modelList = this._appService.getModelList();
      this.isLoading = true;
      this._loadingService.startLoading();
      Observable.forkJoin(componentMakeList, customerList, jobsiteList, familyList, makeList, modelList).subscribe(results => {
          this._availableComponentMakes = results[0];
          this._dropDownLists.customerList = results[1];
          this._dropDownListsFiltered.customerList = results[1];
          this.loadSystemByRoute(RouteControl.Customer);
          this._dropDownLists.jobSiteList = results[2];
          this.loadSystemByRoute(RouteControl.JobSite);
          this._dropDownLists.familyList = results[3];
          this._dropDownLists.makeList = results[4];
          this._dropDownLists.modelList = results[5].filter(m => m);


      }, error => {
          console.error(error);
      }, () => { 
          this.getRouterParams(); 
          this._loadingService.finishedLoading();
           this.isLoading = false; 
          });

      // this._loading++;
      // this._setupService.getComponentMakeList().subscribe(result => { this._availableComponentMakes = result; }, error => { }, () => { this._loading--; });
      // this._loading++;
      // this._appService.getCustomerListForSelection(1, 10000).subscribe(result => { this._dropDownLists.customerList = result; this._dropDownListsFiltered.customerList = result; this.loadSystemByRoute(RouteControl.Customer); }, error => { console.error(error); }, () => { this._loading--; });
      // this._loading++;
      // this._appService.getJobSiteListForSelection(1, 10000).subscribe(result => { this._dropDownLists.jobSiteList = result; this.loadSystemByRoute(RouteControl.JobSite); }, error => { console.error(error); }, () => { this._loading--; });
      // this._loading++;
      // this._appService.getFamilyListForSelection(1, 10000).subscribe(result => { this._dropDownLists.familyList = result; }, error => { console.error(error); }, () => { this._loading--; });
      // this._loading++;
      // this._appService.getMakeListForSelection(1, 10000).subscribe(result => { this._dropDownLists.makeList = result; }, error => { console.error(error); }, () => { this._loading--; });
      // this._loading++;
      // this._appService.getModelListForSelection(1, 10000).subscribe(result => {
      //   this._dropDownLists.modelList = result.filter(m => m);

      // },
      //    error => { console.error(error);    }, () => { this._loading--; });

      // this.leftchainTableDatabase = new ComponentTableDatabase(this._leftChainSetup.Components);
      // this.leftchainTableDataSource = new ComponentDataSource(this.leftchainTableDatabase);

      // this.leftframeTableDatabase = new ComponentTableDatabase();
      // this.leftframeTableDataSource = new ComponentDataSource(this.leftframeTableDatabase);

      this.wireUpTableDataSourceLeftChainTableDatasource(this._leftChainSetup.Components);
      this.wireUpTableDataSourceFrameTableDatasource(this._leftFrameSetup.Components);

      this.getRouteParam(this._appService.getLastRouteMessage());
      this.routeSubscription = this._appService.getRouteMessage().subscribe(message => setTimeout(() => { this.getRouteParam(message); }, 10));

      this._appService.getApplicationConfigValue("UseMaxComponents").subscribe(result => {
          this.useMax = result
      });

  }
  bShowAllPartsIds:boolean=false;
  ShowPartsIds(event: any){
      console.log("Event", event)
this.bShowAllPartsIds=event.checked;
if(this.bShowAllPartsIds){
  this._displayedColumns = ['delete', 'Component', 'Type', 'Pos', 'Brand', 'OEMPartNo','MFRPartNo','BudgetLife', 'HoursAtInstall', 'InstallCost', 'Size', 'Grouser','CleanerHoles'];
}else{
  this._displayedColumns = ['delete', 'Component', 'Type', 'Pos', 'Brand','BudgetLife', 'HoursAtInstall', 'InstallCost', 'Size', 'Grouser','CleanerHoles'];
}
 
  }
  //getUSEystemType
  getUseSystem(equipmentId:number){
      this._setupService.getEquipmentApplication(equipmentId).subscribe(useSystem => {
          if (useSystem) {
              this.hideSerial = false;
          } else {
              this.hideSerial = true;
          }
          //console.log(this.skipChainSetup, useSystem);
      });
  }
  // enJobiteId, enSystemType, enEquipmentId, enSelectedSystem
  getRouterParams() {
      const jobsiteParam = this.route.snapshot.paramMap.get('id');
      const systemTypeParam = this.route.snapshot.paramMap.get('id2');
      const equipmentIdParam = this.route.snapshot.paramMap.get('id3');
      const selectedSystemIdParam = this.route.snapshot.paramMap.get('id4');
      if (jobsiteParam === undefined || systemTypeParam === undefined || selectedSystemIdParam === undefined || equipmentIdParam === undefined ||
          jobsiteParam === null || systemTypeParam === null || selectedSystemIdParam === null || equipmentIdParam === null
      ) {
          this.isCreatingFromAction = false;
          return;
      }
      this.isCreatingFromAction = true;
      console.log(jobsiteParam, systemTypeParam, equipmentIdParam, selectedSystemIdParam);
      this.jobsiteId = this._appService.simpleNumberDecrypt(jobsiteParam);
      this.systemType = this._appService.simpleNumberDecrypt(systemTypeParam);
      this.equipmentId = this._appService.simpleNumberDecrypt(equipmentIdParam);
      this.selectedSystemId = this._appService.simpleNumberDecrypt(selectedSystemIdParam);

      const jobsiteFromParam = this._dropDownLists.jobSiteList.filter(j => j.Id === this.jobsiteId);
      if (jobsiteFromParam.length === 0) {
          this.isCreatingFromAction = false;
          return;
      }

      this._setupService.GetEquipmentMakeModelFamily(this.equipmentId).subscribe(a => {
          this._equipment = a;

          
          if(this._equipment.Family.Id==177 || this._equipment.Family.Id==203){
            this._displayedColumns = ['delete', 'Component', 'Type', 'Pos', 'Brand', 'BudgetLife', 'HoursAtInstall','PMUAtInstall', 'InstallCost', 'Size', 'Grouser','CleanerHoles'];
        }
          const equipMake = this._dropDownLists.makeList.filter(ma => ma.Id === this._equipment.Make.Id);
          if (equipMake.length > 0) {
              this._currentSelection.make = equipMake[0];
              this._dropDownListsFiltered.modelList = this._dropDownLists.modelList.filter(m => m.MakeId === this._currentSelection.make.Id);
          }
          const equipModel = this._dropDownLists.modelList.filter(ma => ma.Id === this._equipment.Model.Id);
          if (equipModel.length > 0) {
              this._currentSelection.model = equipModel[0];
              this.modelChanged({ value: this._currentSelection.model });
          }

          this.getUseSystem( this.equipmentId);

          this._setupService.GetSystemStructureInfo(this.selectedSystemId).subscribe(originalSystem => {
            this._originalSystem = originalSystem;
            console.log("system", this.systemType);
            if (this.selectedSystemId > 0) {
                this.Installed = true;
            }
            // console.log(r);
            // console.log(this._leftChainSetup);
            // console.log(this._leftFrameSetup);
            let modelTemplateList: SystemModelTemplate[] = [];
            if (this.systemType === 1) {
                modelTemplateList = this._setupService.getModelTemplateListForChain(this._systemTemplate);
                for (let i = 0; i < originalSystem.ComponentsOnSystem.length; i++) {
                    const component = this._leftChainSetup.Components.filter(m => m.Compart.CompartType.Id === originalSystem.ComponentsOnSystem[i].CompartTypeId);
                    const existingNumber = component.length;
                    console.log(existingNumber, originalSystem.ComponentsOnSystem[i].EqUnitInfos.length);
                    if (existingNumber < originalSystem.ComponentsOnSystem[i].EqUnitInfos.length) {
                        const shouldAddCount = originalSystem.ComponentsOnSystem[i].EqUnitInfos.length - existingNumber;
                        console.log(shouldAddCount);
                        for (let c = 0; c < shouldAddCount; c++) {
                            this.addComponent(1, originalSystem.ComponentsOnSystem[i].CompartTypeId);
                        }
                    }
                }
            } else {
                modelTemplateList = this._setupService.getModelTemplateListForFrame(this._systemTemplate);
                for (let i = 0; i < originalSystem.ComponentsOnSystem.length; i++) {
                    const component = this._leftFrameSetup.Components.filter(m => m.Compart.CompartType.Id === originalSystem.ComponentsOnSystem[i].CompartTypeId);

                    const existingNumber = component.length;
                    console.log(existingNumber, originalSystem.ComponentsOnSystem[i].EqUnitInfos.length);
                    if (existingNumber < originalSystem.ComponentsOnSystem[i].EqUnitInfos.length) {
                        const shouldAddCount = originalSystem.ComponentsOnSystem[i].EqUnitInfos.length - existingNumber;
                        console.log(shouldAddCount);
                        for (let c = 0; c < shouldAddCount; c++) {
                            this.addComponent(3, originalSystem.ComponentsOnSystem[i].CompartTypeId);
                        }
                    }
                }
            }
        });

      });




      this._currentSelection.customer = this._dropDownLists.customerList.filter(c => c.Id === jobsiteFromParam[0].CustomerId)[0];
      this._dropDownListsFiltered.jobSiteList = this._dropDownLists.jobSiteList.filter(j => j.CustomerId === this._currentSelection.customer.Id);
      this._currentSelection.jobSite = jobsiteFromParam[0];

      if (this.systemType === 1) {
          this._selectedSystemTypeIsChain = true;
          this._selectedIndex =1;

      } else if (this.systemType === 2) {
          this._selectedSystemTypeIsChain = false;
          this._selectedIndex =1;
      }


      if (this.systemType === 0) {
          this.systemType = 1;
          this.shouldShouldChainAndFrameSelection = true;
      }

    
     
     
  }


  wireUpTableDataSourceLeftChainTableDatasource(leftChainComponents: ComponentSetup[]) {
    this.leftchainTableDatabase = new ComponentTableDatabase(leftChainComponents);
    this.leftchainTableDataSource = new ComponentDataSource(this.leftchainTableDatabase);


}
wireUpTableDataSourceFrameTableDatasource(leftFrameComponents: ComponentSetup[]) {
    this.leftframeTableDatabase = new ComponentTableDatabase(leftFrameComponents);
    this.leftframeTableDataSource = new ComponentDataSource(this.leftframeTableDatabase);
}

  ngOnDestroy() {
      this.translateSubscription.unsubscribe();
      this.routeSubscription.unsubscribe();
  }

  updateUserLang(lang: string) {
      this.userLanguage = lang;
      this.ref.detectChanges();
  }

  Translate(value: string): string {
      return this._translate.translateToLang(value, this.userLanguage);
  }

  getRouteParam(message: AppRoute): void {
      if (message.itemId) {
          this._routeId = message.itemId;
          this.loadSystemByRoute(RouteControl.Route);
      }
  }
  loadSystemByRoute(control: RouteControl) {
      if (this._routeId === 0) return;
      if (this._currentSelection.system.Id === this._routeId)
          return;
      if (!this._LoadedLists.find(m => m === control))
          this._LoadedLists.push(control);

      if (!this._LoadedLists.find(m => m === RouteControl.Customer) || !this._LoadedLists.find(m => m === RouteControl.JobSite) || !this._LoadedLists.find(m => m === RouteControl.Route))
          return;

      this._loading++;
      this._setupService.GetSelectedSystemForSelectionInInventory(this._routeId).subscribe(result => {
          if (!result || result.Id === 0) return;

          const jobsite = this._dropDownLists.jobSiteList.find(m => m.Id === result.JobsiteId);
          if (!jobsite) return;

          const customer = this._dropDownLists.customerList.find(m => m.Id === jobsite.CustomerId);
          if (!customer) return;

          this._currentSelection.customer = customer;
          this.customerChanged({ value: customer });

          this._currentSelection.jobSite = jobsite;
          this.jobsiteChangedByRoute({ value: jobsite, system: result });

      }, error => { console.log(error); }, () => { this._loading--; });
  }

  jobsiteChangedByRoute(event: any) {
      const jobsite: JobSite = event.value;
      if (!jobsite || jobsite.Id === 0) return;
      this._loading++;
      this._dropDownListsFiltered.systemList = [];
      this._currentSelection.system = new UCSystem();
      this._currentSelection.jobSite = jobsite;
      this._setupService.getSystemListForSetupInInventory(jobsite.Id, 1, 10000).subscribe(result => {
          this._dropDownListsFiltered.systemList.push(...result);
          this._dropDownListsFiltered.makeList = [];
          this._dropDownListsFiltered.makeList.push(...this._dropDownLists.makeList);
          this._updateExisting = true;
          this.systemChanged({ value: event.system });
          this.nextStep();
      }, error => { console.log(error); }, () => { this._loading--; });
  }

  private selectSystem(system: UCSystem) {
      this._currentSelection.system = system;
      this.updateAvailableComparts(system.Model.Id);
      if (!this._availableComponentMakes.find(m => m.Id === this._currentSelection.system.Make.Id))
          this._availableComponentMakes.unshift(this._currentSelection.system.Make);
      this._loading++;
      this._systemTemplate = [];
      this._setupService.GetTemplateForModel(system.Model.Id).subscribe(template => {
          this._systemTemplate.push(...template);
          this._selectedSystemTypeIsChain = (system.SystemType === SystemType.Chain ? true : false);
          if (this._updateExisting)
              this.setSystemDetailsComponents(this._currentSelection.system.SystemType);
          else {
              this.setSystemDetailsComponents(SystemType.Chain);
              this.setSystemDetailsComponents(SystemType.Frame);
          }
      }, error => { console.error(error); }, () => { this._loading--; });
  }

  setSystemDetailsComponents(_systemType: SystemType) {
      if (_systemType === SystemType.Chain) {
          if (this._currentSelection.system.Id === 0) {
              this._leftChainSetup.Side = Side.Left;
              this._leftChainSetup.Type = SystemType.Chain;
              this._leftChainSetup.JobsiteId = this._currentSelection.jobSite.Id;
              this._leftChainSetup.Make = this._currentSelection.make;
              this._leftChainSetup.Model = this._currentSelection.model;
              this._leftChainSetup.Family = this._currentSelection.family;
              this.setSystemComponents(SystemTypeSide.LeftChain);
          } else {
              this._loading++;
              this._setupService.getSystemForSetupUpdate(this._currentSelection.system.Id).subscribe(
                  result => {
                      this._leftChainSetup = result;
                      this.setSystemComponents(SystemTypeSide.LeftChain);
                      this.leftchainTableDatabase.dataChange.next(this._leftChainSetup.Components);
                  }, error => { console.error(error); }, () => { this._loading--; }
              );
          }
      } else if (_systemType === SystemType.Frame) {
          if (this._currentSelection.system.Id === 0) {
              this._leftFrameSetup.Side = Side.Left;
              this._leftFrameSetup.Type = SystemType.Frame;
              this._leftFrameSetup.JobsiteId = this._currentSelection.jobSite.Id;
              this._leftFrameSetup.Make = this._currentSelection.make;
              this._leftFrameSetup.Model = this._currentSelection.model;
              this._leftFrameSetup.Family = this._currentSelection.family;
              this.setSystemComponents(SystemTypeSide.LeftFrame);
          } else {
              this._loading++;
              this._setupService.getSystemForSetupUpdate(this._currentSelection.system.Id).subscribe(
                  result => {
                      this._leftFrameSetup = result;
                      this.setSystemComponents(SystemTypeSide.LeftFrame);
                      this.leftframeTableDatabase.dataChange.next(this._leftFrameSetup.Components);
                  }, error => { console.error(error); }, () => { this._loading--; }
              );
          }
      }
      this.leftchainTableDatabase.dataChange.next(this._leftChainSetup.Components);
      this.leftframeTableDatabase.dataChange.next(this._leftFrameSetup.Components);
  }

  setSystemComponents(_typeSide: SystemTypeSide) {

      let modelTemplateList: SystemModelTemplate[] = [];
      if (_typeSide === SystemTypeSide.LeftChain || _typeSide === SystemTypeSide.RightChain)
          modelTemplateList = this._setupService.getModelTemplateListForChain(this._systemTemplate);
      else if (_typeSide === SystemTypeSide.LeftFrame || _typeSide === SystemTypeSide.RightFrame)
          modelTemplateList = this._setupService.getModelTemplateListForFrame(this._systemTemplate);


      const components: ComponentSetup[] = [];

      const listposition = 1;
      if (_typeSide === SystemTypeSide.LeftChain) {
          this.setComponent(this._leftChainSetup, modelTemplateList);
          // for (const template of modelTemplateList) {
          //     const existingNumber = this._leftChainSetup.Components.filter(m => m.Compart.CompartType.Id === template.CompartTypeId).length;
          //     for (let k = existingNumber; k < template.Min; k++) {
          //         const newcomponent = this.getNewDefaultComponent(template.CompartTypeId);
          //         newcomponent.SystemId = this._leftChainSetup.Id;
          //         newcomponent.EquipmentSMU = this._leftChainSetup.SmuAtInstall;
          //         newcomponent.InstallDate = this._leftChainSetup.InstallationDate;
          //         newcomponent.Pos = k + 1;
          //         this._leftChainSetup.Components.push(newcomponent);
          //     }
          // }
      } else if (_typeSide === SystemTypeSide.LeftFrame) {
          this.setComponent(this._leftFrameSetup, modelTemplateList);
          // for (const template of modelTemplateList) {
          //     const existingNumber = this._leftFrameSetup.Components.filter(m => m.Compart.CompartType.Id === template.CompartTypeId).length;
          //     for (let k = existingNumber; k < template.Min; k++) {
          //         const newcomponent = this.getNewDefaultComponent(template.CompartTypeId);
          //         newcomponent.EquipmentSMU = this._leftFrameSetup.SmuAtInstall;
          //         newcomponent.InstallDate = this._leftFrameSetup.InstallationDate;
          //         newcomponent.SystemId = this._leftFrameSetup.Id;
          //         newcomponent.Pos = k + 1;
          //         this._leftFrameSetup.Components.push(newcomponent);
          //     }
          // }
      }

      this.reorderSystemComponents(_typeSide);
      this.resetSelectedListIndex(_typeSide);
  }



  private setComponent(systemSetup: SystemSetup, modelTemplateList: SystemModelTemplate[]): SystemSetup {
      var value;
      for (const template of modelTemplateList) {
          const existingNumber = systemSetup.Components.filter(m => m.Compart.CompartType.Id === template.CompartTypeId).length;
          if (this.Installed == true) {
          }
          else {
              if (this.useMax == "0")
                  value = template.Min;
              else
                  value = template.Max;

              for (let k = existingNumber; k < value; k++) {
                  const newcomponent = this.getNewDefaultComponent(template.CompartTypeId);
                  newcomponent.EquipmentSMU = systemSetup.SmuAtInstall;
                  newcomponent.InstallDate = systemSetup.InstallationDate;
                  newcomponent.SystemId = systemSetup.Id;
                  newcomponent.Pos = k + 1;
                  systemSetup.Components.push(newcomponent);
              }
          }
      }
      return systemSetup;
  }

  private getNewDefaultComponent(typeId: number): ComponentSetup {
    const result = new ComponentSetup();
    result.Compart.CompartType = this._setupService.getAvailableCompartTypeList().find(m => m.Id === typeId);
    const systemBrand = this._availableComponentMakes.find(m => m.Id === this._currentSelection.system.Make.Id);
    if (systemBrand)
        result.Brand = systemBrand;
    return result;
}

  customerChanged(event: any): void {
      const customer: Customer = event.value;
      if (!customer) return;
      this._dropDownListsFiltered.jobSiteList = this._dropDownLists.jobSiteList.filter(m => m.CustomerId === customer.Id);
      this._dropDownListsFiltered.makeList = [];
      this._dropDownListsFiltered.modelList = [];
      this._dropDownListsFiltered.systemList = [];
      this._currentSelection.jobSite = new JobSite();
  }

  jobsiteChanged(event: any): void {
      const jobsite: JobSite = event.value;
      if (!jobsite || jobsite.Id === 0) return;
      this._loading++;
      this._dropDownListsFiltered.systemList = [];
      this._currentSelection.system = new UCSystem();
      this._currentSelection.jobSite = jobsite;
      this._setupService.getSystemListForSetupInInventory(jobsite.Id, 1, 10000).subscribe(result => {
          this._dropDownListsFiltered.systemList.push(...result);
          this._dropDownListsFiltered.makeList = [];
          this._dropDownListsFiltered.makeList.push(...this._dropDownLists.makeList);
      }, error => { console.log(error); }, () => { this._loading--; });


  }

  updateExistingChanged(event: any) {
      this._currentSelection.system = new UCSystem();
      this._currentSelection.make = new Make();
      this._currentSelection.model = new Model();
      this._currentSelection.family = new Family();
      this._selectedSystemTypeIsChain = true;
      this.location.go('setup-undercarriage/in-inventory/');
      this.Installed = true;
  }
  unlockInputs() {
      if (this.isCreatingFromAction) {
          this._notification.warn('In the middle of creating system for actions, these fields cannot be changed');
          return;
      }
      this._lockModel = false;
  }

  systemChanged(event: any): void {
      const system: UCSystem = event.value;
      if (!system) return;
      this.selectSystem(system);
      if (system.Id !== 0) {
          this.location.go('setup-undercarriage/in-inventory/' + system.Id);
          this.Installed = true;
      }
  }

  makeChanged(event: any): void {
      const make: Make = event.value;
      if (!make) return;
      this._currentSelection.make = make;
      this._dropDownListsFiltered.modelList = this._dropDownLists.modelList.filter(m => m.MakeId === make.Id);
      this._currentSelection.model = new Model();
  }

  modelChanged(event: any): void {
      const model: Model = event.value;
      if (!model) return;


      this._currentSelection.system.Make = this._currentSelection.make;
      this._currentSelection.system.Model = model;
      this._currentSelection.system.Family = this._dropDownLists.familyList.find(m => m.Id === model.FamilyId);
      this._currentSelection.family = this._dropDownLists.familyList.find(m => m.Id === model.FamilyId);
      this._currentSelection.system.SystemType = this.systemType;
      this._currentSelection.system.JobsiteId = this._currentSelection.jobSite.Id;

      // console.log( this._currentSelection);
      this.selectSystem(this._currentSelection.system);
      this.getFamilyDetails(model.FamilyId);

  }

  updateModelTemplate(modelId: number) {
      this._loading++;
      this._systemTemplate = [];
      this._setupService.GetTemplateForModel(modelId).subscribe(template => {
          this._systemTemplate.push(...template);
      }, error => { console.error(error); }, () => { this._loading--; });
  }

  // returning true makes button disable
  checkTemplateForCompartTypeButton(_typeSide: SystemTypeSide, typeId: number): boolean {
      if (this.getCompartTypeRemainingOptional(_typeSide, typeId) > 0)
          return false;
      return true;
  }

  checkTemplateForCompartRemoveFromList(_typeSide: SystemTypeSide, typeId: number): boolean {
      const _selectedComponents = this.getSystembyTypeSide(_typeSide).Components;
      const template = this._systemTemplate.find(m => m.ModelId === this._currentSelection.system.Model.Id && m.CompartTypeId === typeId);
      const count = _selectedComponents.filter(m => m.Compart.CompartType.Id === typeId).length;
      if (template && count > template.Min) return true;
      return false;
  }

  private updateAvailableComparts(modelId) {
    this._loading++;
    this._currentAvailableTypes = [];
    this._setupService.GetAvailableCompartsAll(modelId).subscribe(result => {
        this._currentAvailableTypes.push(...result);
    }, error => { }, () => { this._loading--; });
}

  getAvailableCompartList(typeId: number): Compart[] {
    return this._currentAvailableTypes.filter(m => m.CompartType.Id === typeId);
}


  private updatemodelMatchingLabel(_typeSide: SystemTypeSide, typeId: number) {
      const _currentSystem = this.getSystembyTypeSide(_typeSide);
      const k = this.getCompartTypeRemainingRequired(_typeSide, typeId);
      const p = this.getCompartTypeRemainingOptional(_typeSide, typeId);
  }


  CompartSelected(event: any, element: ComponentSetup) {
    if (!event.value) return;
    const selected = this._currentAvailableTypes.find(m => m.Id === event.value);
    if (!selected) return;
    element.Compart = selected;

    // if (!this.shouldPreFillBudgetLife(element)) {
    //     element.BudgetLife = selected.DefaultBudgetLife;
    // }

    if (selected.BudgetLife === 0) {
        if (element.BudgetLife === 0 || element.BudgetLife === null) {
            element.BudgetLife = selected.DefaultBudgetLife;
        }
    } else {
        element.BudgetLife = selected.BudgetLife;
    }


}


shouldPreFillBudgetLife(element: ComponentSetup): boolean {
    if (this._originalSystem !== null && this._originalSystem !== undefined) {
        const sameCompartType = this._originalSystem.ComponentsOnSystem.find(c => c.CompartTypeId === element.Compart.CompartType.Id && c.EqUnitInfos.length > 0);
        if (sameCompartType !== undefined) {
            const sameComponent = sameCompartType.EqUnitInfos.find(eq => eq.Position === element.Pos);
            if (sameComponent !== undefined)
                element.BudgetLife = sameComponent.BudgetLife;
            return true;
        }
    }
    return false;
}
  soheSizeSelected(event: any, element: ComponentSetup) {
      if (!event.value)
          return;
      const selected = this._availableShoeSizes.find(m => m.Id === event.value);
      if (!selected)
          return;
      element.ShoeSize = selected;
  }

  grouserSelected(event: any, element: ComponentSetup) {
      if (!event.value) return;
      const selected = this._availableGrousers.find(m => m.Id === event.value);
      if (!selected) return;
      element.Grouser = selected;
  }

  cleanerHolesChange(event: any, element: ComponentSetup) {
    console.log("event.value_____", event.value)
            if (!event.value) return;
            const selected = event.value;
            if (!selected) return;
            element.HasCleanerHoles = selected;
    
        }

  brandSelected(event: any, element: ComponentSetup) {
      if (!event.value) return;
      const selected = this._availableComponentMakes.find(m => m.Id === event.value);
      if (!selected) return;
      element.Brand = selected;
  }

  LeftFrameCannonChange(event:any){
    console.log("LeftFrameCannonChange", event.value)
    this._leftFrameSetup.cannonType = event.value;
}
LeftFrameConfigChange(event:any){
    console.log("LeftFrameConfigChange", event.value)
    this._leftFrameSetup.frameConfig = event.value;
}

  addComponent(_typeSide: SystemTypeSide, typeId: number) {
      const system = this.getSystembyTypeSide(_typeSide);
      if (this.getCompartTypeRemainingOptional(_typeSide, typeId) === 0) {
          this.openSnackBar(this.Translate('Cannot add more components of this type!'), this.Translate('NOT ALLOWED'));
          return;
      }
      const component = this.getNewDefaultComponent(typeId);
      component.Pos = this.getNewPosition(_typeSide, typeId);
      component.EquipmentSMU = system.SmuAtInstall;
      component.InstallDate = system.InstallationDate;
      component.SystemId = system.Id;
      component.listPosition = system.Components.length + 1;
      system.Components.push(component);

      this.resetSystemPositionIndex(_typeSide);
      this.reorderSystemComponents(_typeSide);
      this.resetSelectedListIndex(_typeSide);

      this.updateTableView(_typeSide);
  }

  removeElement(_typeSide: SystemTypeSide, element: ComponentSetup): void {
      const system = this.getSystembyTypeSide(_typeSide);
      const component = system.Components.findIndex(m => m.listPosition === element.listPosition && m.Id === element.Id);
      if (component < 0) {
          this.openSnackBar(this.Translate('Cannot find this component to remove!'), this.Translate('FAILED!'));
          return;
      }

      system.Components.splice(component, 1);
      this.reorderSystemComponents(_typeSide);
      this.resetSelectedListIndex(_typeSide);
      this.resetSystemPositionIndex(_typeSide);
      this.updateTableView(_typeSide);
  }

  updateTableView(_typeSide: SystemTypeSide) {
      if (_typeSide === SystemTypeSide.LeftChain)
          this.leftchainTableDatabase.dataChange.next(this._leftChainSetup.Components);
      else if (_typeSide === SystemTypeSide.LeftFrame)
          this.leftframeTableDatabase.dataChange.next(this._leftFrameSetup.Components);
  }

  getNewPosition(_typeSide: SystemTypeSide, typeId: number): number {
      const system = this.getSystembyTypeSide(_typeSide);
      const filtered = system.Components.filter(m => m.Compart.CompartType.Id === typeId);
      if (filtered) {
          const lastposition = Math.max(...filtered.map(m => m.Pos));
          return lastposition + 1;
      }
      return 1;
  }


  logSystems() {
      console.log('available shoe sizes', this._availableShoeSizes);
      console.log('available shoe grouser', this._availableGrousers);
      console.log('available types', this._currentAvailableTypes);
      console.log('leftChain:', this._leftChainSetup);
      console.log('leftFrame:', this._leftFrameSetup);
  }

  private reorderSystemComponents(_typeSide: SystemTypeSide) {
      const system = this.getSystembyTypeSide(_typeSide);
      system.Components = system.Components.sort((a, b) => this.compartOrder(a, b));
  }

  private resetSelectedListIndex(_typeSide: SystemTypeSide) {
      const system = this.getSystembyTypeSide(_typeSide);
      let k = 0;
      for (const i of system.Components) {
          i.listPosition = ++k;
      }
  }

  private resetSystemPositionIndex(_typeSide: SystemTypeSide) {
      const components = this.getSystembyTypeSide(_typeSide).Components;
      for (const t of this._setupService.getAvailableCompartTypeList()) {
          const filtered = components.filter(m => m.Compart.CompartType.Id === t.Id).sort((a, b) => (a.Pos > b.Pos ? 1 : -1));
          let k = 0;
          for (const p of filtered) {
              p.Pos = ++k;
          }
      }
      return components;
  }


  private compartOrder(a: ComponentSetup, b: ComponentSetup): number {

      if (a.Compart.CompartType.Order > b.Compart.CompartType.Order)
          return 1;
      if (a.Compart.CompartType.Order < b.Compart.CompartType.Order)
          return -1;
      if (a.Pos > b.Pos)
          return 1;
      return -1;
  }

  formatDate(date: Date) {
      if (!date) return '-';
      date = new Date(date);
      const monthNames = [
          'January', 'February', 'March',
          'April', 'May', 'June', 'July',
          'August', 'September', 'October',
          'November', 'December'
      ];
      const day = date.getDate();
      const monthIndex = date.getMonth();
      const year = date.getFullYear();

      return day + '/' + monthNames[monthIndex] + '/' + year;
  }

  private dateOnly(date: Date): Date {
      if (!date) return new Date();
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  private dateOnlyFromUTCString(dateUTC: string): Date {
      if (!dateUTC)
          return new Date();
      if (dateUTC.indexOf('T') === -1)
          return new Date();
      const date = new Date(dateUTC);
      if (!date) return new Date();
      const result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      return result;
  }

  private getSystembyTypeSide(_typeSide: SystemTypeSide): SystemSetup {
      if (_typeSide === SystemTypeSide.LeftChain)
          return this._leftChainSetup;
      if (_typeSide === SystemTypeSide.LeftFrame)
          return this._leftFrameSetup;
      return new SystemSetup();
  }

  private getCompartTypeRemainingRequired(_typeSide: SystemTypeSide, compartTypeId: number): number {
    const _selectedComponents = this.getSystembyTypeSide(_typeSide).Components;
    const template = this._systemTemplate.find(m => m.ModelId === this._currentSelection.system.Model.Id && m.CompartTypeId === compartTypeId);
    const count = _selectedComponents.filter(m => m.Compart.CompartType.Id === compartTypeId).length;
    if (template) {
        return (template.Min - count > 0) ? (template.Min - count) : 0;
    }
}

  private getCompartTypeRemainingOptional(_typeSide: SystemTypeSide, compartTypeId: number): number {
      const _selectedComponents = this.getSystembyTypeSide(_typeSide).Components;
      const template = this._systemTemplate.find(m => m.ModelId === this._currentSelection.system.Model.Id && m.CompartTypeId === compartTypeId);
      const count = _selectedComponents.filter(m => m.Compart.CompartType.Id === compartTypeId).length;
      if (template) {
          return (template.Max - count > 0) ? (template.Max - count) : 0;
      }
  }

  checkComponentsForTemplate(_typeSide: SystemTypeSide): boolean {
      const modelTemplateChainList = this._setupService.getModelTemplateListForChain(this._systemTemplate);
      const modelTemplateFrameList = this._setupService.getModelTemplateListForFrame(this._systemTemplate);
      const _selectedComponents = this.getSystembyTypeSide(_typeSide).Components;
      for (const tmplt of modelTemplateChainList) {
          let count = 0;
          if (_selectedComponents && _selectedComponents.length > 0)
              count = _selectedComponents.filter(m => m.Compart.CompartType.Id === tmplt.CompartTypeId && m.Compart.Model.Id === tmplt.ModelId).length;
          if (count < tmplt.Min || count > tmplt.Max) {
              return false;
          }
      }
      return true;
  }


  showResultMessage(item: ResultMessage): boolean {
      if (item.Id === 0 && item.OperationSucceed)
          return false;
      return true;
  }

  resultMapper(result: ResultMessage): void {
      console.log('resultMapper result -> ', result);
  }

  openSnackBar(message: string, action: string) {
      this.snackBar.open(message, action, {
          duration: 5000,
      });
  }


  nextStep() {
      //console.log('nextStep _selectedIndex', this._selectedIndex, this.systemType);
      if (this._selectedIndex === 2 && this.StepValidation(this._selectedIndex).OperationSucceed) {
          if (this._updateExisting) {
              this.SubmitAll();
          } else {
              this.ValidateSerialNo();
          }
          return;
      }

      if (this._selectedIndex == 1) {
        if (this._selectedSystemTypeIsChain) {
            for (const component of this._leftChainSetup.Components) {
                component.InstallDate = this._leftChainSetup.InstallationDate;
            }
        } else if (!this._selectedSystemTypeIsChain) {
            for (const component of this._leftFrameSetup.Components) {
                component.InstallDate = this._leftFrameSetup.InstallationDate;
            }
        }
    }

      if (this.StepValidation(this._selectedIndex).OperationSucceed) {
          this._selectedIndex++;
          if (this._selectedIndex === 1) {
              this._lockModel = true;
          }
          if (this._selectedIndex === 1) {
              if (this._selectedSystemTypeIsChain) {
                  this.leftchainTableDatabase.data.forEach(lc => lc.HoursAtInstall = this._leftChainSetup.HoursAtInstall);
                  this.leftchainTableDatabase.data.forEach(lc => lc.PMUAtInstall = this._leftChainSetup.PMUAtInstall);

              } else {
                  this.leftframeTableDatabase.data.forEach(lf => lf.HoursAtInstall = this._leftFrameSetup.HoursAtInstall);
                  this.leftframeTableDatabase.data.forEach(lf => lf.PMUAtInstall = this._leftFrameSetup.PMUAtInstall);

              }
          }

      }
  }

  // step -> which step needs to be validated?
  StepValidation(step: number): ResultMessage {
      const result = new ResultMessage();
      result.OperationSucceed = false;

      if (step === 0 && (this._currentSelection.jobSite.Id === 0)) {
          result.LastMessage = this.Translate('JobSite is not selected!');
          return result;
      }

      if (step === 0 && this._updateExisting && this._currentSelection.system.Id === 0) {
          result.LastMessage = this.Translate('System is not selected!');
          return result;
      }

      if (step === 0 && !this._updateExisting && (this._currentSelection.model.Id === 0)) {
          result.LastMessage = this.Translate('Model is not selected!');
          return result;
      }

      if (step === 1) { // System Details
          // There is no validation for step 1
          // Assign Hours install here


      }

      if (step === 2 || step === 3) {
          let failed = false;
          if(this.SMUHours==null || this.SMUHours==undefined || this.SMUHours<0 ){
            failed = true;
          }
          if (this._selectedSystemTypeIsChain) {
              for (const component of this._leftChainSetup.Components) {
                  if (!this.validateComponent(SystemTypeSide.LeftChain, component).OperationSucceed) {
                      failed = true;
                      break;
                  }
              }
          } else if (!this._selectedSystemTypeIsChain) {
              for (const component of this._leftFrameSetup.Components) {
                  if (!this.validateComponent(SystemTypeSide.LeftFrame, component).OperationSucceed) {
                      failed = true;
                      break;
                  }
              }
          }

          if (failed) {
              result.OperationSucceed = false;
              result.LastMessage = this.Translate('Validation failed!');
              return result;
              
          }
      }
      result.OperationSucceed = true;
      result.LastMessage = 'Validation passed.';
      return result;
  }

  validateComponent(_typeSide: SystemTypeSide, component: ComponentSetup): ResultMessage {
      const result: ResultMessage = new ResultMessage();
      result.OperationSucceed = false;
      const system = this.getSystembyTypeSide(_typeSide);
      if (!system) {
          result.OperationSucceed = true;
          result.LastMessage = this.Translate('System cannot be found!'); // It is not a failure for component
          return result;
      }


      if (!component.Compart || component.Compart.Id === 0) {
          result.LastMessage = this.Translate('Validation failed: Type is not selected!');
          return result;
      }

      if (!component.Compart.CompartType || component.Compart.CompartType.Id === 0) {
          result.LastMessage = this.Translate('Validation failed: Compart Type is not selected!');
          return result;
      }
      // Unknown item added and is initially selected so no need for this validation
      /*if (component.Compart.CompartType.Id == 232) { //means component is a shoe
          if (!component.ShoeSize || component.ShoeSize.Id == 0) {
              result.LastMessage = this.Translate('Validation failed: Shoe size is not selected!');
              return result;
          }
          if (!component.Grouser || component.Grouser.Id == 0) {
              result.LastMessage = this.Translate('Validation failed: Shoe grouser is not selected!');
              return result;
          }
      }*/

      if (!component.Brand || component.Brand.Id === 0) {
          result.LastMessage = this.Translate('Validation failed: Brand is not selected!');
          return result;
      }
      result.OperationSucceed = true;
      result.LastMessage = this.Translate('Validation Passed.');
      return result;
  }

  showPosition(component: ComponentSetup): string {
      if (!component || !component.Pos || !component.Compart || !component.Compart.CompartType || !component.Compart.CompartType.Id)
          return '';
      return this._appService.getPositionString(component.Pos, component.Compart.CompartType.Id);
  }

  stepChangedManually(event: any) {
      if(this.isCreatingFromAction ==false)
      {
      this._selectedIndex = event.selectedIndex;
      let backwardSteps: number = event.selectedIndex;
      let failedStep: number = event.selectedIndex;
      if (event.selectedIndex > event.previouslySelectedIndex) {
          while (backwardSteps > 0) {
              if (!this.StepValidation(backwardSteps - 1).OperationSucceed)
                  failedStep = backwardSteps - 1;
              backwardSteps--;
          }
      }
      if (this._selectedIndex !== failedStep)
          setTimeout(() => { this.openSnackBar(this.Translate('Previous step validation failed!'), this.Translate('Warning')); this._selectedIndex = failedStep; }, 1000);
      else if (event.selectedIndex > event.previouslySelectedIndex && event.selectedIndex === 1)
          this._lockModel = true;
  }
 
  }

  private ValidateSerialNo() {
      let serialNo;
      if (this._selectedSystemTypeIsChain) {
          serialNo = this._leftChainSetup.Serial;
      } else {
          serialNo = this._leftFrameSetup.Serial;
      }
      this._setupService.checkSystemSerialNo(serialNo).subscribe(r => {
          if (!r) {
              this.SubmitAll();
          } else {
              this._notification.error('Operation failed!', 'That system serial number already exists! Please enter a valid serial number.');
          }
      });
  }


  setupNewUC() {
      this.submittedSucessfully = false;
      this._leftChainSetup = new SystemSetup();
      this._leftFrameSetup = new SystemSetup();
      this._currentSelection = new CurrentSelection();
      this.wireUpTableDataSourceFrameTableDatasource(this._leftFrameSetup.Components);
      this.wireUpTableDataSourceLeftChainTableDatasource(this._leftChainSetup.Components);
      this._dropDownListsFiltered.makeList = this._dropDownLists.makeList;
      this._dropDownListsFiltered.modelList = this._dropDownLists.modelList;
      this._dropDownListsFiltered.customerList = this._dropDownListsFiltered.customerList;
      this._dropDownListsFiltered.jobSiteList = this._dropDownListsFiltered.jobSiteList;
      this._lockModel = false;
      this._selectedIndex = 0;
  }
  getFormatedDate = (currentDate) => {
  
    console.log("curernt ", currentDate)
    let dd = currentDate.getDate();
    let mm = currentDate.getMonth() + 1; // January is 0!
    const yyyy = currentDate.getFullYear();
    if (dd < 10) {
      dd = `0${dd}`;
    }
    if (mm < 10) {
      mm = `0${mm}`;
    }
    return `${dd} ${mm} ${yyyy}`;
  };

  private SubmitAll() {
      let systems: SystemSetup[] = [];
      if (this._selectedSystemTypeIsChain){
          this._leftChainSetup.InstallationDate_ = this.getFormatedDate(new Date(this._leftChainSetup.InstallationDate));
        systems = [this._leftChainSetup];
      }
        
      else{
        this._leftFrameSetup.InstallationDate_ = this.getFormatedDate(new Date(this._leftFrameSetup.InstallationDate));
        systems = [this._leftFrameSetup];
      } 
      this._loading++;

      console.log("selectedSystem ", systems)
      this._setupService.submit2SystemsInInventory(systems).subscribe(result => {

          console.log(result);

          for (const system of result) {
              if (system.Type === SystemType.Chain) {
                  this._leftChainSetup = system;
                  this.wireUpTableDataSourceLeftChainTableDatasource(this._leftChainSetup.Components);
              } else if (system.Type === SystemType.Frame) {
                  this._leftFrameSetup = system;
                  this.wireUpTableDataSourceLeftChainTableDatasource(this._leftFrameSetup.Components);
              }
          }
          this.showSubmitMessage();
      }, error => { console.log(error); }, () => { this._loading--; });
  }

  backToAction() {
      console.log("backkkkkk")
      let createdSystemId = 0;
      if (this._selectedSystemTypeIsChain) {
          createdSystemId = this._leftChainSetup.Id;
          this.action.ActionDate = this._leftChainSetup.InstallationDate;
      } else {
          createdSystemId = this._leftFrameSetup.Id;
          this.action.ActionDate = this._leftFrameSetup.InstallationDate;
      }
      
      //this.action.ActionDate = this._leftFrameSetup.InstallationDate;
      this.action.LabourCostOption = 0;
      this.action.PartCost = 0;
      this.action.LabourCost = this.LabourCost;
      this.action.MiscCost = this.MiscCost;
      this.action.ActionTypeId = 34;
      this.action.Reed = 0;
      this.action.ExtendedBudgetLife = 0;

      this.action.Comment=this.Comment;
      this.action.EquipmentId=this.equipmentId;
      this.action.NewSMU=this.SMUHours;
      this.action.NewPMU=this.PMUHours;
      //this.action.StringDate=this._leftFrameSetup.InstallationDate.toISOString();
      console.log("actionfo____", this.action);
      this._actionService.SystemReplacement(this.action, createdSystemId, this.selectedSystemId,false).subscribe(a => {
        console.log("actionInfo", this.action, createdSystemId, this.selectedSystemId);
        this._loadingService.finishedLoading();

        if (a.OperationSucceed) {
         // this.succesfullySubmitted = true;
          this._notification.success('System successfully replaced');
          this._router.navigate(['equipment', this.equipmentId]);
        } else {
          //this._actioning = false;
          this._notification.error('System can not be replaced due to' + a.Message);
        }
      });
     // this._router.navigate(['record-actions', this.equipmentId, createdSystemId, this.selectedSystemId]);
  
  }

  showSubmitMessage() {
      let systems: SystemSetup[] = [];
      if (this._selectedSystemTypeIsChain)
          systems = [this._leftChainSetup];
      else systems = [this._leftFrameSetup];
      let succeeded = true;
      for (const system of systems) {
          if (!system.Result.OperationSucceed) {
              succeeded = false;
              break;
          }
          for (const component of system.Components) {
              if (!component.Result.OperationSucceed) {
                  succeeded = false;
                  break;
              }
          }
          if (!succeeded) break;
      }
      if (succeeded) {
          this.submittedSucessfully = true;
          //this._notification.success('Operation Succeeded!', 'All submitted successfully!');
          if(this.isCreatingFromAction){
              this.backToAction();
          }
      } else
          this._notification.error('Operation failed!', 'At least one component or system failed to setup! please check your input!');
  }
  shouldSelectDefault(element: ComponentSetup) {
    
    const compartElement = this.getAvailableCompartList(element.Compart.CompartType.Id);


    // if (this._originalSystem !== null && this._originalSystem !== undefined) {
    //     const originalCompartOnSystem = this._originalSystem.ComponentsOnSystem.find(c => c.CompartTypeId === element.Compart.CompartType.Id);
    //     if (originalCompartOnSystem !== null && originalCompartOnSystem !== undefined && originalCompartOnSystem.EqUnitInfos.length > 0) {
    //         const posFind = originalCompartOnSystem.EqUnitInfos.find(e => e.Position === element.Pos);
    //         if (posFind !== null && posFind !== undefined) {
    //             this.CompartSelected({ value: posFind.CompartId }, element);
    //             return element.Compart.Id;
    //         } else {
    //             this.CompartSelected({ value: originalCompartOnSystem.EqUnitInfos[0].CompartId }, element);
    //             return element.Compart.Id;
    //         }
    //     }
    // } else
     if (element.Compart.Id !== 0 && compartElement.length > 0) {
        this.CompartSelected({ value: element.Compart.Id }, element);
        return element.Compart.Id;
    } else {
        if (compartElement !== undefined && compartElement !== null && compartElement.length === 1) {
            this.CompartSelected({ value: compartElement[0].Id }, element);
            return element.Compart.Id;
        }

    }
}

  getImage(image: string) {

      return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);
  }


  getFamilyDetails(value: number) {
      this._setupService.getFamilyList().subscribe(res => {
          if (res != null) {
                const familydetails = res;
                familydetails.map(x => {
                    if (x.type_auto === value) {
                        this.FamilyImage_Chain = x.ChainImage;
                        this.FamilyImage_Frame = x.FrameImage;
                    }
                });
            }
      });
  }

  ShowError:boolean=false;
  UpdateLife(sysType:number){
      if(sysType==1){//Chain
        if(this._equipment.Family.Id==177 ||this._equipment.Family.Id==203){
            if(Number( this._leftChainSetup.HoursAtInstall)< Number(this._leftChainSetup.PMUAtInstall)){
                this.ShowError=true; 
             }else{
                 this.ShowError=false;
              }
        }
        for (const component of this._leftChainSetup.Components) {
            component.HoursAtInstall = this._leftChainSetup.HoursAtInstall;
        }
        
    }
    else{
        if(this._equipment.Family.Id==177 ||this._equipment.Family.Id==203){
            if(Number( this._leftFrameSetup.HoursAtInstall)< Number(this._leftFrameSetup.PMUAtInstall)){
                this.ShowError=true; 
             }else{
                 this.ShowError=false;
              }
        }
        for (const component of this._leftFrameSetup.Components) {
            component.HoursAtInstall = this._leftFrameSetup.HoursAtInstall;
        }
    }

  }

  UpdatePMU(sysType:number){
    if(sysType==1){//Chain
        if(this._equipment.Family.Id==177 ||this._equipment.Family.Id==203){
        if(Number( this._leftChainSetup.HoursAtInstall)< Number(this._leftChainSetup.PMUAtInstall)){
            this.ShowError=true; 
         }else{
             this.ShowError=false;
          }
        }
      for (const component of this._leftChainSetup.Components) {
          component.PMUAtInstall = this._leftChainSetup.PMUAtInstall;
      }
  }
  else{
    if(this._equipment.Family.Id==177 ||this._equipment.Family.Id==203){
        if(Number( this._leftFrameSetup.HoursAtInstall)< Number(this._leftFrameSetup.PMUAtInstall)){
            this.ShowError=true; 
         }else{
             this.ShowError=false;
          }
    }
      for (const component of this._leftFrameSetup.Components) {
          component.PMUAtInstall = this._leftFrameSetup.PMUAtInstall;
      }
  }

}
  // End of component class
}


///Extra classes for ComponentList Table Data Source
class ComponentTableDatabase {
  dataChange: BehaviorSubject<ComponentSetup[]> = new BehaviorSubject<ComponentSetup[]>([]);
  get data(): ComponentSetup[] { return this.dataChange.value; }
  constructor(_equipmentList: ComponentSetup[]) {
      this.dataChange.next(_equipmentList);
  }
}


class ComponentDataSource extends DataSource<any> {
  constructor(private _componentDatabase: ComponentTableDatabase) {
      super();
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<ComponentSetup[]> {
      return this._componentDatabase.dataChange.asObservable();
  }

  disconnect() { }
}
